export const API_LOADING = "API_LOADING"
export const API_LOADED = "API_LOADED"
export const API_ERROR = "API_ERROR"
